import { useState } from 'react';
import { useMutation } from 'react-query';
import { useToast } from '@razorpay/blade/components';
import { SEND_REMINDER } from 'api/missingInformationReport';
import api from 'api';
import { AppError } from 'utils/AppError';
import { parseError } from 'utils/Api';
import { MissingReportType } from 'api/types/missingInformationReportTypes';

export const useSendReminder = (reminderType?: MissingReportType) => {
  const [isSendReminderModalOpen, setIsSendReminderModalOpen] = useState(false);
  const [remindEmployeeIds, setRemindEmployeeIds] = useState<(string | number)[]>([]);
  const toast = useToast();

  const onCloseModal = () => {
    setIsSendReminderModalOpen(false);
    setRemindEmployeeIds([]);
  };

  const { mutate: sendReminder, isLoading: isSendingReminder } = useMutation({
    mutationKey: [SEND_REMINDER, reminderType].filter(Boolean),
    mutationFn: api.missingInformationReport.sendReminder,
    onSuccess: () => {
      toast.show({
        content: 'Reminder sent successfully',
        color: 'positive',
      });
      onCloseModal();
    },
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseError(error),
        color: 'negative',
      });
    },
  });

  return {
    remindEmployeeIds,
    isSendReminderModalOpen,
    sendReminder,
    isSendingReminder,
    onOpenModal: ({
      remindEmployeeIds,
    }: {
      remindEmployeeIds?: (string | number)[];
    } = {}) => {
      setIsSendReminderModalOpen(true);
      setRemindEmployeeIds(remindEmployeeIds ?? []);
    },
    onCloseModal,
  };
};
